import { useUserSetting } from "core/hooks/useUserSetting";

export function usePreferredTemperatureUnit() {
  return useUserSetting<"C" | "F">("tempUnit", "C");
}
